const FULL_WIDTH = '100%';

export default {
  containerRef: null,

  init(containerRef: React.RefObject<Element>): void {
    this.containerRef = containerRef;
  },

  resize(plusHeight = 70): void {
    const height = this.containerRef.current.getBoundingClientRect().height;
    window.AP.resize(FULL_WIDTH, `${height + plusHeight}px`);
  },
};
